import NeptuneElement from '../../NeptuneElement.js';

class Card extends NeptuneElement {

    static CARD_TYPES = [
        'default',
        'flat',
        'dark'
    ];

    templateMarkup = `
    <section>
        <slot name="header"></slot>
        <slot name="body"></slot>
        <slot name="footer"></slot>
    </section>
    `;

    componentCssUrl = '/src/components/container/card/card.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.validateRequiredProperties(['type']);
        this.processInitialAttributesAfterRender(Card.observedAttributes);
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['type', 'show-elevation'];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (!this.isRendered) {
            return;
        }

        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        switch (name) {
            case 'type': {
                this.validatePropertyValue(name, newValue, Card.CARD_TYPES);
                break;
            }
            case 'show-elevation': {
                this.validatePropertyValue(name, newValue, ['', 'true', 'false']);
                break;
            }
            default:
                break;
        }
    }
}

customElements.define('neptune-card', Card);
export default Card;